import React, { Fragment, useEffect, useState, useContext } from 'react'
import { useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { buildVenueOpenGraph } from '@blocktickets/shared-utils'

import LoadingContext from '../../context/Loading/Loading'
import { ModalsProvider } from '../../components/PurchaseFlow/NewCheckoutWrapper/providers/ModalsProvider'

import {
  getVenueUpcomingEvents,
  getVenuePackages,
  getVenueFlexPacks,
  getVenueAccessPasses,
} from '../../utilities/api'

import { PageLoadingContainer, VenueInformation } from '../../components'
import OpenGraph from '../../components/OpenGraph/OpenGraph'

import { initializeTracking } from '../../utilities/tracking'

export default function VenuePage() {
  const { isLoading, showLoading, hideLoading } = useContext(LoadingContext)

  let { slug } = useParams()

  const [venue, setVenue] = useState()

  const [packages, setPackages] = useState()

  const [accessPasses, setAccessPasses] = useState()

  const [flexPacks, setFlexPacks] = useState()

  useEffect(() => {
    showLoading()
    getVenueUpcomingEvents(slug)
      .then((res) => {
        const venue = res.data
        const organization = res.data?.allEvents?.[0]?.organization
        initializeTracking(organization)
        setVenue(venue)
        getVenuePackages(venue?.uuid)
          .then((res) => {
            setPackages(res?.data)
            getVenueAccessPasses(venue?.uuid)
              .then((accessPassRes) => {
                setAccessPasses(accessPassRes?.data || [])
              })
              .catch((err) => console.error(err))
            getVenueFlexPacks(venue.id).then((res) => {
              setFlexPacks(res?.data)
            })
          })
          .catch((err) => console.error(err))
      })
      .finally(() => hideLoading())
  }, [slug])

  const openGraph = buildVenueOpenGraph(venue)

  return (
    <Fragment>
      <OpenGraph {...openGraph} />
      <Helmet>
        <meta charSet="utf-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1"
        />
        <meta name="theme-color" content="#000000" />
        <meta name="keywords" content={openGraph.description} />
      </Helmet>
      {isLoading ? (
        <PageLoadingContainer />
      ) : (
        <section>
          <ModalsProvider>
            <VenueInformation
              venue={venue}
              packages={packages}
              accessPasses={accessPasses}
              flexPacks={flexPacks}
            />
          </ModalsProvider>
        </section>
      )}
    </Fragment>
  )
}
